import { RootState } from "@/redux/store"
import { routes } from "@/routes/utils";
import { useSelector } from "react-redux"
import { useGetLifeCycle } from "@/services";
import moment from "moment";
import { Badge } from "@/components/ui";
import { capitalize, cn } from "@/lib/utils";

const useFiscalYearLifecycle = () => {
  const {currentFinanceYear, communityData} = useSelector((state: RootState) => state.currentData);

  const { 
    data: lifeCycleData, 
    isLoading: isLifeCycleLoading
  } = useGetLifeCycle({                                                                         
      communityId: communityData?.communityId,
      queryParams:{
        enabled: !!communityData?.communityId
      }                                                                                           
    })  
 
  // Define Table Columns
  const columns = [
    {
      accessorKey: "fiscalYear",
      header: "Fiscal Year",
      accessorFn: (row: any) => String(row?.fiscalYear || ""),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({row}: any) => {
        const isClosed = row.original.status.toLowerCase() === "closed";
        return (
          <Badge
            variant="outline"
            className={cn(
              !isClosed
                ? "border-green-600 bg-green-100 text-green-600"
                : "border-gray-600 bg-gray-100 text-gray-600",
              "rounded-full px-4 py-2"
            )}
          >
            {isClosed ? "Carry Forward" : capitalize(row.original.status)}
          </Badge>
        );
      },
    },
    {
      accessorKey: "updatedAt",
      header: "Updated At",
      accessorFn: (row: any) =>
        row?.updatedAt ? moment(row?.updatedAt).format("MM/DD/YYYY [at] hh:mm A") : "",
    },
    {
      accessorKey: "updatedByName",
      header: "Updated By",
      accessorFn: (row: any) =>String(row?.updatedByName||""),
        
    },
  ];
  

  const breadcrumbData = [
    {
      link: `/${routes.admin}/${routes.activityDashboard}`,
      name: `Activity Dashboard - ${communityData?.communityName || communityData?.name || ""}`,
    },
    {
      link: "",
      name: "Fiscal Year Life Cycle",
    },
  ];

  return {
    currentFinanceYear,
    columns,
    breadcrumbData,
    communityData,
    data:lifeCycleData||[],
    isLifeCycleLoading
  }
}

export default useFiscalYearLifecycle;
